import { ReactNode } from "react";

export interface IOfferTagProps {
    iconEl?: ReactNode;
    title: string;
    bgColor?: OfferTagBgClass;
}

export enum OfferTagBgClass {
    OFFER_BUNDLE,
    HABIT_FORMING_MILESTONE_UNLOCKED,
}
